/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import { toasterState } from "Components/common/toaster";
import makeApi, { URLS } from "Utils/apiURL";
import Button from "Components/common/Button";
import Utils from "Utils/utils";
import { tagsStoreData } from "Stores/TagsData";
import PersonalInformation from "Components/common/contact/PersonalInformation";
import CompanyInformation from "Components/common/contact/CompanyInformation";
import ContactNotes from "Components/common/contact/ContactNotes";
import LocationInformation from "Components/common/contact/LocationInformation";
import ContactTags from "Components/common/contact/ContactTags";
import SocialLinks from "Components/common/contact/SocialLinks";
import ContactCustomFields from "Components/common/contact/ContactCustomFields";
import { contactStoreData } from "Stores/contactData";
import { SINGLE_CONTACT_UPLOADING_MANDATORY_FIELDS } from "Static/constant";

class EditContactPopupState {
  @observable showPopup = false;
  @observable contact = false;
  @observable callback = null;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      this.popupValues = this.defaultPopupValue;
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  };

  @action
  setContact = val => {
    this.contact = val;
  };

  @action
  setCallback = val => {
    this.callback = val;
  };
}

const editContactPopupState = new EditContactPopupState();

const SectionCard = ({ title, description = "", children, className = "" }) => (
  <section className={`editPopupCard ${className}`}>
    <header className="editPopupCardHeader">
      <h3 className="editPopupCardTitle">{title}</h3>
      {description && (
        <p className="editPopupCardDescription">{description}</p>
      )}
    </header>
    <div className="editPopupCardBody">{children}</div>
  </section>
);

const EditContactPopup = props => {
  const defaultInputState = editContactPopupState.contact;
  const [inputVal, setInputVal] = useState(defaultInputState);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [showTagDropDown, setShowTagDropDown] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [selectedTags, setSelectedTags] = useState(inputVal.contactTags);

  const changeInputVal = (id, data, flag) => {
    if (flag === "customFields") {
      const stateObj = { ...inputVal };
      const customFields = stateObj["customFields"];
      if (customFields) {
        customFields[id] = data;
        setInputVal(stateObj);
      } else {
        const tempObj = {};
        tempObj[id] = data;
        stateObj.customFields = tempObj;
        setInputVal(stateObj);
      }
    } else {
      const stateObj = { ...inputVal };
      stateObj[id] = data;
      setInputVal(stateObj);
    }
  };

  const submitAction = async ev => {
    if (ev?.target?.checkValidity()) {
      ev.preventDefault();
      try {
        setButtonLoader(true);
        const payload = getEditContactPayload();
        const response = await saveContact(payload);
        if (response && response.data) {
          handleUpdateContactResponse(response.data);
        } else {
          Utils.showApiFailureResponse(response);
          setButtonLoader(false);
          closeAction();
        }
      } catch (e) {
        handleUpdateContactFailure();
      }
    } else {
      ev?.target?.reportValidity();
    }
  };

  const getEditContactPayload = () => {
    if (inputVal && Object.keys(inputVal).length) {
      const payload = {};
      const contact = {};
      if (selectedTags && selectedTags.length) {
        const extractedTagsArray = Utils.extractTagNameFromList(selectedTags);
        payload.contactTags = extractedTagsArray;
      }
      contact.firstName = inputVal.firstName || null;
      contact.lastName = inputVal.lastName || null;
      contact.email = inputVal.email || null;
      contact.linkedinId = Utils.removeHttpFromString(
        inputVal.linkedinId || null
      );
      if (inputVal?.mobilePhone?.length) {
        contact.mobilePhone = Array.isArray(inputVal.mobilePhone)
          ? inputVal.mobilePhone
          : [inputVal.mobilePhone];
      }
      if (inputVal?.otherPhone?.length) {
        contact.otherPhone = Array.isArray(inputVal.otherPhone)
          ? inputVal.otherPhone
          : [inputVal.otherPhone];
      }
      if (inputVal?.phone?.length) {
        contact.phone = Array.isArray(inputVal.phone)
          ? inputVal.phone
          : [inputVal.phone];
      }
      contact.company = inputVal.company || null;
      contact.jobTitle = inputVal.jobTitle || null;
      contact.industry = inputVal.industry || null;
      contact.street = inputVal.street || null;
      contact.city = inputVal.city || null;
      contact.state = inputVal.state || null;
      contact.country = inputVal.country || null;
      contact.zipCode = inputVal.zipCode || null;
      contact.website = inputVal.website || null;
      contact.facebook = inputVal.facebook || null;
      contact.twitter = inputVal.twitter || null;
      contact.contactNotes = inputVal.contactNotes || null;
      contact.customFields =
        Utils.addNullForEmptyObject(inputVal.customFields) || null;
      contact.id = inputVal.id || null;
      payload.contacts = [contact];
      return payload;
    }
  };

  const saveContact = payload => {
    const config = {
      url: URLS.updateContactsToDirectory,
      method: "POST",
      data: payload
    };
    return makeApi(config);
  };

  const handleUpdateContactResponse = response => {
    const responseCode = response.responseCode ? response.responseCode : "";
    if (responseCode && responseCode === 200) {
      const extractedTagsArray = Utils.extractTagNameFromList(selectedTags);
      tagsStoreData.getAllTags();
      let message = "Contact has been updated successfully";
      toasterState.setToastMsg(message, "success");
      const contactdata = response.contact;
      setButtonLoader(false);
      closeAction();
      editContactPopupState.setContact(contactdata);
      editContactPopupState.callback(contactdata, extractedTagsArray);
    } else if (responseCode === 400) {
      setButtonLoader(false);
      let message = "Email Address or LinkedIn url is mandatory for a contact.";
      toasterState.setToastMsg(message, "failure");
    } else if (responseCode === 409) {
      setButtonLoader(false);
      let message =
        "A contact already exists with the same email address or LinkedIn profile. Please check and try again.";
      toasterState.setToastMsg(message, "failure");
    } else if (responseCode === 403) {
      setButtonLoader(false);
      closeAction();
      let message = "You don't have editing access to this contact.";
      toasterState.setToastMsg(message, "failure");
    } else {
      handleUpdateContactFailure();
    }
  };

  const handleUpdateContactFailure = () => {
    setButtonLoader(false);
    toasterState.setToastMsg("Failed to update contact", "failure");
  };

  const closeAction = () => {
    editContactPopupState.setShowPopup(false);
    contactStoreData.setUpdateContactEmail("");
    setSelectedTags([]);
  };

  const addSelectedTagsInTagList = (tagList, existingTags) => {
    if (existingTags && existingTags.length) {
      tagList &&
        tagList.map(obj => {
          const { value } = obj;
          if (value && existingTags.includes(value)) {
            obj.checked = true;
          }
        });
    }
    setTagList([...tagList]);
  };

  useEffect(() => {
    if (defaultInputState && Object.keys(defaultInputState).length) {
      setInputVal(defaultInputState);
      setSelectedTags(defaultInputState.contactTags);
      addSelectedTagsInTagList(tagList, defaultInputState.contactTags);
    }
  }, [defaultInputState]);

  useEffect(() => {
    if (tagsStoreData.tagsData) {
      addSelectedTagsInTagList(
        Utils.createObjWithoutRef(tagsStoreData.tagsData),
        null
      );
    }
  }, [tagsStoreData.tagsData]);

  if (!editContactPopupState.showPopup || !inputVal) {
    return "";
  }

  return (
    <div className="popupWrapper editContactPopup editContactPopupV2">
      <div className="common-popup-mask editPopupMask" onClick={closeAction} />
      <div className="confirmation-popup common-popup editPopupShell">
        <form
          className="popup-wrap editPopupForm"
          onSubmit={e => submitAction(e)}
          autoComplete="off"
        >
          {showTagDropDown && (
            <div
              className="transparentOverlay"
              onClick={() => setShowTagDropDown(false)}
            />
          )}

          <header className="editPopupHeader">
            <div className="editPopupHeaderLeft">
              <h2 className="editPopupTitle">Edit Contact</h2>
              <p className="editPopupSubtitle">
                Update the contact&apos;s details and click Save to apply changes.
              </p>
            </div>
            <button
              type="button"
              className="editPopupClose"
              onClick={closeAction}
              title="Close"
              aria-label="Close"
            >
              <i className="material-icons">close</i>
            </button>
          </header>

          <div className="editPopupBody">
            <SectionCard title="Personal Information">
              <PersonalInformation
                changeInputVal={changeInputVal}
                inputVal={inputVal}
                tokenList={SINGLE_CONTACT_UPLOADING_MANDATORY_FIELDS}
                isEditContact={true}
                originalEmail={editContactPopupState.contact?.email || ""}
              />
            </SectionCard>

            <div className="editPopupRow companyAndNotes">
              <SectionCard
                title="Company Information"
                className="companySection"
              >
                <CompanyInformation
                  changeInputVal={changeInputVal}
                  tokenList={SINGLE_CONTACT_UPLOADING_MANDATORY_FIELDS}
                  inputVal={inputVal}
                />
              </SectionCard>
              <SectionCard title="Contact Notes" className="notesSectionCard">
                <ContactNotes
                  changeInputVal={changeInputVal}
                  inputVal={inputVal}
                />
              </SectionCard>
            </div>

            <SectionCard title="Location">
              <LocationInformation
                changeInputVal={changeInputVal}
                inputVal={inputVal}
              />
            </SectionCard>

            <SectionCard title="Social Links">
              <SocialLinks
                changeInputVal={changeInputVal}
                inputVal={inputVal}
              />
            </SectionCard>

            <SectionCard title="Contact Tags" className="tagsSectionCard">
              <ContactTags
                tagsList={tagList}
                setTagList={setTagList}
                showTagDropDown={showTagDropDown}
                setShowTagDropDown={setShowTagDropDown}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
              />
            </SectionCard>

            <SectionCard
              title="Custom Fields"
              className="customFieldsSectionCard"
            >
              <ContactCustomFields
                changeInputVal={changeInputVal}
                customFieldsValue={inputVal.customFields || {}}
              />
            </SectionCard>
          </div>

          <footer className="editPopupFooter">
            <button
              type="button"
              className="editPopupCancelBtn"
              onClick={closeAction}
            >
              Cancel
            </button>
            <Button
              type="submit"
              btnText="Save Changes"
              className={`positive-btn editPopupSaveBtn ${
                buttonLoader ? "loading" : ""
              }`}
              loader={buttonLoader}
            />
          </footer>
        </form>
      </div>
    </div>
  );
};

export { EditContactPopup, editContactPopupState };
export default observer(EditContactPopup);
